import React from 'react';

export type ImageFetchPriority = 'high' | 'low' | 'auto';

type ImageContextValue = {
  loading: JSX.IntrinsicElements['img']['loading'];
  fetchPriority?: ImageFetchPriority;
};

const ImageContext = React.createContext<ImageContextValue>({ loading: 'lazy', fetchPriority: 'auto' });

type ImageProviderProps = ImageContextValue & {
  children?: React.ReactNode;
};

export const ImageProvider: React.FC<ImageProviderProps> = ({ loading, fetchPriority = 'auto', children }) => {
  return <ImageContext.Provider value={{ loading, fetchPriority }}>{children}</ImageContext.Provider>;
};

export const useImage = (): ImageContextValue => React.useContext(ImageContext);
